import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingTemplate } from '../interfaces/setting-template.interface';

@Injectable({
	providedIn: 'root',
})
export class SettingTemplateService {
	readonly url: string = 'SettingTemplate';

	constructor(private http: HttpClient) {}

	public getAllSettingTemplates(): Observable<SettingTemplate[]> {
		return this.http.get<SettingTemplate[]>(this.url + '/' + 'GetAllSettingTemplates');
	}

	public getSettingTemplateByLinkTemplateId(linkTemplateId: number): Observable<SettingTemplate[]> {
		return this.http.get<SettingTemplate[]>(this.url + '/' + 'LinkTemplateId' + '/' + linkTemplateId);
	}

	public updateSettingTemplateIndexAndGrouping(settingTemplate: SettingTemplate[]): Observable<boolean> {
		return this.http.post<boolean>(this.url + '/' + 'BatchUpdateSettingTemplates', settingTemplate);
	}

	public updateSingleSettingTemplate(settingTemplate: SettingTemplate): Observable<boolean> {
		return this.http.post<boolean>(this.url, settingTemplate);
	}
}
